<template lang="html">
  <div class="btnBlock">
      <a  @click="printme"><i class="fas fa-file-pdf"></i></a>
  <a  @click="printmeMassive">TEST</a>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PrintOfPdf",
  props : [
    "ofid"
  ],
  methods: {
    printme : function(){
      axios
        .get(
          "https://crm.bonbonprint.fr/api/index.php/of/printTheOdt?ofid="+this.ofid+"&direct=true",
          {
            headers: {
              'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9' //the token is a variable which holds the token
            }
          }
        )
        .then(response => {
          // axios.post(
          //     "http://bonbonprint.candyprint.eu/ws/odttopdfconverter",
          //     {fileUrl:"http://crm.bonbonprint.fr"+response.data},
          //   )
          //   .then(r => {
          //     var pdfcontent = r.data.fileContent;
          //     var pdfname = "OF-"+this.ofid+".pdf";
          //     const linkSource = "data:application/pdf;base64,"+pdfcontent;
          //     const downloadLink = document.createElement("a");
          //     const fileName = pdfname;
          //     downloadLink.href = linkSource;
          //     downloadLink.download = fileName;
          //     downloadLink.click();
          //   });

          var pdfname = "OF-"+this.ofid+".odt";
          const linkSource = "https://crm.bonbonprint.fr"+response.data;
          const downloadLink = document.createElement("a");
          const fileName = pdfname;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();


        });
    },

    printmeMassive : function(){
      axios
        .post(
          "https://crm.bonbonprint.fr/api/index.php/of/printTheOdtMass?direct=true",
          {ofarray : [5518, 5502]},
          {
            headers: {
              'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9' //the token is a variable which holds the token
            }
          }
        )
        .then(response => {
          console.log(response);
          response.data = response.data.map(x => "http://crm.bonbonprint.fr"+x);

          axios.post(
                "https://bonbonprint.candyprint.eu/ws/odttopdfconvertermass",
                {fileUrls:response.data},
              )
          .then(r => {
                var pdfcontent = r.data.fileContent;
                var pdfname = "OFs.pdf";
                const linkSource = "https://bonbonprint.candyprint.eu/ws"+pdfcontent;
                const downloadLink = document.createElement("a");
                const fileName = pdfname;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                console.log(pdfcontent);
            });



          // var pdfname = "OF-"+this.ofid+".odt";
          // const linkSource = "https://crm.bonbonprint.fr"+response.data;
          // const downloadLink = document.createElement("a");
          // const fileName = pdfname;
          // downloadLink.href = linkSource;
          // downloadLink.download = fileName;
          // downloadLink.click();


        });
    },

  }
}
</script>

<style lang="css" scoped>
</style>
